import { Toaster as Sonner } from "sonner";

/** Toasts (sonner): announced politely to assistive technologies. */
export function Toaster() {
  return (
    <Sonner
      position="bottom-right"
      closeButton
      toastOptions={{
        classNames: {
          toast: "!rounded-md !border !border-line !bg-raised !text-fg !shadow-overlay",
          description: "!text-muted",
        },
      }}
    />
  );
}
